module.exports = __webpack_public_path__ + "static/img/home_yali_photo3@2x.b173562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_yali_photo3@2x.png
// module id = 5KU2
// module chunks = 0